module.exports = __webpack_public_path__ + "img/slack-btn.a333a01b.png";